export const noOp = (..._: any[]): void => {
  // do nothing.
};
